import { render } from "./Unit3BackBtn.vue?vue&type=template&id=2279c25e&scoped=true"
import script from "./Unit3BackBtn.vue?vue&type=script&lang=js"
export * from "./Unit3BackBtn.vue?vue&type=script&lang=js"

import "./Unit3BackBtn.vue?vue&type=style&index=0&id=2279c25e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2279c25e"]])

export default __exports__